import { storyblokEditable } from '@storyblok/react'
import { VideoStoryblok } from "@/component-types-sb"

interface VideoProps {
  blok: VideoStoryblok
}

function isEmbedUrl(url: string) {
  return url.includes('youtube.com') || url.includes('youtu.be') || url.includes('vimeo.com')
}

export default function Video({ blok }: VideoProps) {
  const { heading, videoUrl, poster, autoplay, controls, loop, muted } = blok

  return (
    <section {...storyblokEditable(blok)} className="video max-w-[1200px] mx-auto p-5 md:p-10">
      {heading && <h2 className="mb-4">{heading}</h2>}
      {isEmbedUrl(videoUrl) ? (
        <div className="aspect-video w-full">
          <iframe
            src={videoUrl}
            title={heading || 'Video'}
            allow="autoplay; encrypted-media"
            allowFullScreen
            className="w-full h-full border-0"
          />
        </div>
      ) : (
        <video
          src={videoUrl}
          poster={poster?.filename || undefined}
          autoPlay={!!autoplay}
          controls={controls !== false}
          loop={!!loop}
          muted={!!muted}
          className="w-full rounded-lg"
        />
      )}
    </section>
  )
}
